import { render, staticRenderFns } from "./BookingLogin.vue?vue&type=template&id=40531069&"
import script from "./BookingLogin.vue?vue&type=script&lang=ts&"
export * from "./BookingLogin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports